import React from "react";
import { isReloy } from "../../../utils/isClient";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CoinStoreHeader(_ref) {
  var config = _ref.config;
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col justify-center items-center text-center pt-12",
    children: [/*#__PURE__*/_jsx("h2", {
      className: "".concat(config === null || config === void 0 ? void 0 : config.fontTitle, " text-2xl lg:text-3xl font-medium"),
      children: "Loyalty that Rewards You"
    }), isReloy(config) ? /*#__PURE__*/_jsx("p", {
      className: "mt-3 text-sm lg:text-lg ",
      children: "Earn HT Points for every meaningful action and unlock exclusive benefits along the way."
    }) : /*#__PURE__*/_jsx("p", {
      className: "mt-3 text-sm lg:text-lg",
      children: "Now you can earn coins every time you interact with the program. The more you engage, the more you earn, unlocking exciting rewards along the way."
    }), isReloy(config) && /*#__PURE__*/_jsx("div", {
      className: "w-28 h-[2px] mt-6",
      style: {
        background: config === null || config === void 0 ? void 0 : config.primaryColor
      }
    })]
  });
}
export default CoinStoreHeader;